package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.general

import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings


enum class ModeEnum(
    val title:String,
    val value:Int,
) {
    STANDARD(
        title = LanguageManager.getCurrentStrings().standardInBracket,
        value = 0
    ),
    MWST_NORMAL(
        title =LanguageManager.getCurrentStrings().mwstNormal,
        value = 100
    )
}